import { AccountMergeData } from '../../data/account.merge.data';

export class FakeAccountMergeData extends AccountMergeData {

    constructor() {
        super();

        this._id = '0c573a9a-a442-4d40-865b-b2225e13b41d';
        this.name = 'Sample Account';
        this.phone = '02 9999 5555';
        this.email = 'manager@sample.com';
        this.taxId = "taxId91923039";

        this.creditAccountType = 'Credit';
        this.creditLimitAmount = 10000;
        this.creditOutstandingInvoicesAmount = 5000;
        this.creditOverdueInvoicesAmount = 2000;
    }

}